import { sortByProperty } from '../../../util/sort'

let storeList = []

export const setStoreList = (_storeList) => {
    sortByProperty(_storeList, 'displayName')
    storeList = _storeList
}

export const renderStoreName = (storeTechnicalName) => {
    if (!storeList) {
        return storeTechnicalName
    }
    for (let index = 0; index < storeList.length; index++) {
        const store = storeList[index]
        if (store.technicalName === storeTechnicalName) {
            return store.displayName
        }
    }
    return storeTechnicalName
}

export const renderStoreNameById = (storeId) => {
    if (!storeList) {
        return '';
    }
    for (let index = 0; index < storeList.length; index++) {
        const store = storeList[index]
        if (store.id === storeId) {
            return store.displayName
        }
    }
    return '';
}

export const getStoreDropDown = () => {
    return storeList.map(store => ({
        id: store.id,
        value: store.displayName,
    }))
}



// WEBPACK FOOTER //
// ./src/modules/store/util/renderStoreName.js